import PropTypes from "prop-types"
import React, { Component } from "react"

//Simple bar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

import email_broadcast from "../../assets/img/email_broadcast.png"
import mailImg from "../../assets/img/mail.png"
import dealImg from "../../assets/img/handshakeW.png"
import agentImg from "../../assets/img/Agents.png"
//i18n
import { withTranslation } from "react-i18next"
import { hasPermission } from "helpers/checkPermission"


class SidebarContent extends Component {
  constructor(props) {
    super(props)
    this.refDiv = React.createRef()
  }

  componentDidMount() {
    this.initMenu()

    
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu()
    }
  }

  initMenu() {
    new MetisMenu("#side2-menu")

    let matchingMenuItem = null
    const ul = document.getElementById("side2-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
       //
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300
          }
        }
      }
    }, 300)
  }

  activateParentDropdown = item => {
    item.classList.add("active")
    const parent = item.parentElement

    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side2-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      this.scrollElement(item)
      return false
    }
    this.scrollElement(item)
    return false
  }
 
  render() {
    const userModule = localStorage.getItem('userModule');
    const {isResponsive, userdetail } = this.props;
    //console.log(localStorage.getItem('authUser'));
    return (
      <React.Fragment>
        <SimpleBar className="h-100 main-menu" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side2-menu">
            <li>
                <Link to="/#" className=" ">
                  <i className="bx bx-user-plus" />
          
                  <span>{this.props.t("Dashboard")}</span>
                </Link>
              </li>
               <li>
                <Link to="/agent">
                  <img src={agentImg} style={{ width: 24, marginRight: 5 }} />

                  <span>{this.props.t("Agents")}</span>
                </Link>

              </li>
             {hasPermission("RealtorOfficeEvents", "Edit") && (
                  <li>
                    <Link to="/office/events">
                      <i className="bx bxs-building-house" />
                      <span>Office</span>
                    </Link>
                  </li>
                )}
              {hasPermission("RealtorPreConsProjects", "Add") && (
              <li>
                <Link to="/transaction">
                <i className="mdi email_broadcast"><img src={dealImg} width='23px'/></i>
          
                  <span>{this.props.t("Deals")}</span>
                </Link>
                
              </li>
              )}
                {hasPermission("RealtorLeadsActivities", "View") && (
            <li>
                <Link to="/activity" className="">
                  <i className="bx bx-run" />
          
                  <span>{this.props.t("Activities")}</span>
                </Link>
               
              </li>
                )}
              {hasPermission("RealtorLeads", "View") && (
              <li>
                <Link to="/lead/dashboard" className="">
                  <i className="mdi mdi-account-group" />
          
                  <span>{this.props.t("Leads")}</span>
                </Link>
             
              </li>
                )}
       
          
              {hasPermission("RealtorContacts", "View") && (
               <li>
              <Link to="/all-contacts" className="">
                <i className="mdi mdi-account-details"></i>
                <span>{this.props.t("Contacts")}</span>
              </Link>
           
            </li>
              )}
             {hasPermission("RealtorClients", "View") && (
              <li>
                <Link to="/clients" className="">
                <i className="mdi mdi-account-heart" />
          
                  <span>{this.props.t("Clients")}</span>
                </Link>
             
             
              </li>
                 )}
              <li>
                <Link to="/pre-construction/project" className="has-arrow">
                  <i className="bx bxs-school" />
          
                  <span>{this.props.t("Pre-Construction")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                   {hasPermission("RealtorPreConsBuilders", ["View", "Edit", "Add"]) && (
                  <li>
                    <Link to="/pre-construction/builder">{this.props.t("Builders")}</Link>
                  </li>
                    )}
                   {hasPermission("RealtorPreConsProjects", ["View", "Edit", "Add"]) && (
                  <li>
                    <Link to="/pre-construction/my-project">{this.props.t("Projects")}</Link>
                  </li>
                    )}
                 {hasPermission("RealtorPreConsProjects", ["View", "Edit", "Add"]) && (
                   <li>
                    <Link to="/pre-construction/project/lead">{this.props.t("Pre-Construction Leads")}</Link>
                  </li>
                  )}
                   {hasPermission("RealtorPreConsProjects", ["View", "Edit", "Add"]) && (
                  <li>
                    <Link to="/pre-construction/project/clients">{this.props.t("Pre-Construction Clients")}</Link>
                  </li>
                    )}
                   {!isResponsive &&
  hasPermission("RealtorPreConsProjects", ["View", "Edit", "Add"]) && (
    <li>
      <Link to="/landing-page">
        {this.props.t("Landing Page")}
      </Link>
    </li>
  )
}

                      {!isResponsive &&
  hasPermission("RealtorPreConsProjects", ["View", "Edit", "Add"]) && (
                  <li>
                    <Link to="/custom-email-template">{this.props.t("Custom Email Templates")}</Link>
                  </li>
                     )}
                  
                </ul>
              </li>
               {!isResponsive &&(
              <li>
                <Link to="/campaign" className="has-arrow">
                  {/* <i className="mdi mdi-email-plus" /> */}
                  <i className="mdi email_broadcast"><img src={email_broadcast} width='23px'/></i>
          
                  <span>{this.props.t("Campaign")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                <li><Link to="/campaign">{this.props.t("All Campaign")}</Link></li>
                 
                <li><Link to="/all-templates">{this.props.t("Preview Templates")}</Link></li>
                

                <li><Link to="/collection">{this.props.t("Collections")}</Link></li>
                </ul>
              </li>
               )}

              {/* <li>
                <Link to="/transaction" className="has-arrow">
                  <i className="mdi doc_status"><img src={doc_stat} width='23px'/></i>
          
                  <span>{this.props.t("Reports")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false"> 
                <li><Link to="/transaction">{this.props.t("Transactions")}</Link></li>
                <li><Link to="/goal">{this.props.t("Goals")}</Link></li>
                </ul>
              </li> */}
              <li>
                <Link to="/email-inbox" className="">
                  <i className="bx"> <img src={mailImg} width='23px'/></i>
                  <span>{this.props.t("Inbox")}</span>
                </Link>
              
              </li>
              <li>
                <Link to="/setting/agent-profile" className="">
                  <i className="fab fa-whmcs" />
          
                  <span>{this.props.t("Settings")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false"> 
                <li><Link to="/setting/agent-profile">{this.props.t("Profile")}</Link></li>
                {!isResponsive &&(
                  <li><Link to="/setting/general/calendar">{this.props.t("Settings")}</Link></li>
                )}
                
                </ul>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    )
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
  match:PropTypes.object,
  isResponsive:PropTypes.object,
  userdetail:PropTypes.object
}

export default withRouter(withTranslation()(SidebarContent))
